import { render, staticRenderFns } from "./SidebarMenuLink.vue?vue&type=template&id=0b069c02&scoped=true&"
import script from "./SidebarMenuLink.vue?vue&type=script&lang=ts&"
export * from "./SidebarMenuLink.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarMenuLink.vue?vue&type=style&index=0&id=0b069c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b069c02",
  null
  
)

export default component.exports